const requests = new Map();
const STORAGE_KEY = 'work-task-boundary-requests-v1';
function readRequests() {
  try {
    if (!requests.size && typeof localStorage !== 'undefined') {
      for (const [key, value] of JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')) requests.set(key, value);
    }
  } catch (_) {}
}
function persist() {
  try { if (typeof localStorage !== 'undefined') localStorage.setItem(STORAGE_KEY, JSON.stringify([...requests].slice(-40))); } catch (_) {}
}
export function workBoundaryRequestId(taskId, message, fileIds = [], preferred) {
  readRequests();
  const key = JSON.stringify([taskId, message, [...fileIds].map(String).sort()]);
  if (!requests.has(key)) requests.set(key, preferred || `wb_${Date.now()}_${Math.random().toString(36).slice(2)}`);
  persist();
  return requests.get(key);
}
export function finishWorkBoundaryRequest(requestId) {
  readRequests();
  for (const [key, id] of requests) if (id === requestId) requests.delete(key);
  persist();
}
export function boundaryDestination(response) {
  const destination = response?.routing?.action === 'created' ? response.routing.destination : null;
  return destination?.id && destination?.conversationId ? destination : null;
}
